var iCookieLength = 30; // Cookie length in days
var sCookieName = "source"; // Name of the first party cookie to utilise for last click referrer de-duplication
var sSourceParameterName = "source"; // The parameter used by networks and other marketing channels to tell you who drove the traffic

// Dynamically extract top-level domain
var hostnameParts = document.location.hostname.split(".");
var domain = hostnameParts.slice(-2).join("."); // example.com

var _getQueryStringValue = function (sParameterName) {
    var aQueryStringPairs = document.location.search.substring(1).split("&");
    for (var i = 0; i < aQueryStringPairs.length; i++) {
        var aQueryStringParts = aQueryStringPairs[i].split("=");
        if (sParameterName.toLowerCase() == aQueryStringParts[0].toLowerCase()) {
            return aQueryStringParts[1];
        }
    }
};

var _setCookie = function (sCookieName, sCookieContents, iCookieLength, tlDomain) {
    var dCookieExpires = new Date();
    dCookieExpires.setTime(dCookieExpires.getTime() + (iCookieLength * 24 * 60 * 60 * 1000));
    document.cookie = sCookieName + "=" + sCookieContents + "; expires=" + dCookieExpires.toGMTString() +";domain=" + tlDomain +"; path=/;";
};

if (_getQueryStringValue(sSourceParameterName)) {
    _setCookie(sCookieName, _getQueryStringValue(sSourceParameterName), iCookieLength, domain);
}